import React from 'react'
import InterventionAxes from '../components/screens/homescreen/purpose/InterventionAxes'

import './axes-page.css'

const AxesPage = () => (
  <div className='axes-page'>
    <InterventionAxes />
  </div>
)

export default AxesPage
